import { Star } from "lucide-react"

export default function ReviewCarousel() {
  const reviews = [
    {
      name: "Emma van der Berg",
      rating: 5,
      text: "Amazing dodgeball community! The coaches are fantastic and the atmosphere is so welcoming. I've made so many friends here.",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
      role: "Weekly Warrior Member",
    },
    {
      name: "Lars Jansen",
      rating: 5,
      text: "Best workout I've had in years. Fast-paced, fun, and competitive. The variety of games keeps it interesting every time.",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      role: "Drop-in Player",
    },
    {
      name: "Sophie Bakker",
      rating: 5,
      text: "Great for all skill levels. I started as a complete beginner and now I'm addicted! The community is incredibly supportive.",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      role: "Youth Program Graduate",
    },
  ]

  return (
    <div className="w-full">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-4">What Our Players Say</h2>
        <p className="text-xl text-gray-600">Real experiences from our dodgeball community</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {reviews.map((review, index) => (
          <div key={index} className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-shadow reveal">
            <div className="flex items-center gap-4 mb-6">
              <img
                src={review.avatar || "/placeholder.svg"}
                alt={review.name}
                className="w-16 h-16 rounded-full object-cover"
              />
              <div>
                <p className="font-bold text-black text-lg">{review.name}</p>
                <p className="text-[#E67E22] text-sm font-medium">{review.role}</p>
                <div className="flex mt-1">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" />
                  ))}
                </div>
              </div>
            </div>
            <p className="text-gray-700 leading-relaxed text-lg">"{review.text}"</p>
          </div>
        ))}
      </div>
    </div>
  )
}
